import { render, staticRenderFns } from "./LiquidacionProductoFormComponent.vue?vue&type=template&id=f2085b6c&"
import script from "./LiquidacionProductoFormComponent.vue?vue&type=script&lang=js&"
export * from "./LiquidacionProductoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports